import React from "react";
import "./style.css";
import { motion } from "framer-motion";
import { fadeInUp } from "../../../animations/fadeVariants";

const Home = () => {
  return (
    <section id="home" className="content">
      <div className="container">
        <motion.div {...fadeInUp} className="home-text">
          <h1>NRPS</h1>
          <p>
            PT. NIDA ROKAN PUTRI SULUNG adalah sebuah perusahaan yang bergerak
            dalam bidang usaha Leveransir Umum dan Kontraktor. Kami menyediakan
            layanan seperti Gas Metering, Kalibrasi, Upgrading, Instrumentasi,
            Jasa-Jasa pemasangan atau pemindahan material lainnya, dan pengadaan
            material
          </p>
        </motion.div>
        <motion.div {...fadeInUp} style={{ zIndex: "1" }}>
          <a className="find-us" href="#footer">
            Find Us!
          </a>
        </motion.div>
        <div className="overlay"></div>
      </div>
    </section>
  );
};

export default Home;
